var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader text-center"},[_c('i',{staticClass:"fa-4x fa-spin",class:_vm.showIcon}),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }